module.exports = __webpack_public_path__ + "static/message1-9f84cdc7759e8b40ba8896e9fed26d38.jpg";